import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr } from "@revvsales/components";

// Service Imports
import { getEvidenceSummary } from "../../actions/DocumentActions/services";
// Utility Imports
import { GlobalUtils } from "../../utils/index";

// Declarations
const { handleApiErrMsg } = GlobalUtils;
class DocumentDetails extends Component {
  state = {
    isLoading: false,
  };

  _downloadEvidenceSummary = () => {
    if (
      this.props.document.stage === "COMPLETED" &&
      this.props.document.is_sent_for_signature
    ) {
      this.setState({
        isLoading: true,
      });
      getEvidenceSummary(this.props.document.id)
        .then(response => {
          // get the file type
          const docMIMEType = "application/pdf";
          const file = new Blob([response], {
            type: docMIMEType,
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(file, this.props.document.name);
          } else {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(file);
            link.setAttribute("download", this.props.document.name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          this.setState({
            isLoading: false,
          });
          Toastr.showToastr({
            type: "success",
            message: "Your document has been downloaded successfully.",
            timeout: 3000,
          });
        })
        .catch(error => {
          console.error(error);
          this.setState({
            isLoading: false,
          });
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
        });
    }
  };

  render() {
    const { document = {}, currentView, selectedPriceBook } = this.props;
    const {
      docNo,
      quoteTable,
      created_at: docCreatedDate,
      created_by: { name: docOwner, image_url: docOwnerProfileImageUrl } = {},
      account: { name: accountName, address: accountAddress } = {},
      opportunity: {
        name: opportunityName,
        stage_name: oppStage,
        expected_revenue: oppExpectedRevenue,
        close_date: oppCloseDate,
        updated_at: oppLastUpdated,
      } = {},
    } = document;
    let linkedPriceBookName = "-";
    if (selectedPriceBook) {
      linkedPriceBookName = selectedPriceBook;
    } else if (quoteTable && quoteTable.id) {
      linkedPriceBookName = "External Source";
    }
    if (this.state.isLoading) {
      return (
        <Loader
          className="saving-document"
          label="Downloading your esign evidence summary"
          theme="dark"
          fullScreen
        />
      );
    }
    return (
      <div className="context-notes  animated fadeinright">
        <div className="notes-header">
          <span
            data-test="documentdetails-right-pane-title"
            className="right-pane-title documentdetails-pane-title">
            Document information
          </span>
        </div>
        <div
          className={`collab-content collab-content-scroll-${currentView} documentdetails-wrapper`}>
          <div className="content-scroll ">
            {/* Document ID */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "briefcase"]} />
                </span>
                Document ID
              </div>
              <div
                data-test="documentdetails-docinfo-document-id"
                className="documentdetails-col meta-value">
                {docNo || "-"}
              </div>
            </div>

            {/* Opportunity Stage */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "crown"]} />
                </span>
                Opportunity Name
              </div>
              <div
                data-test="documentdetails-docinfo-opportunity-name"
                className="documentdetails-col meta-value">
                {opportunityName || "-"}
              </div>
            </div>

            {/* Opportunity Stage */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "list-ul"]} />
                </span>
                Opportunity Stage
              </div>
              <div
                data-test="documentdetails-docinfo-opportunity-stage"
                className="documentdetails-col meta-value">
                {oppStage || "-"}
              </div>
            </div>

            {/* Linked Pricebook */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "book-spells"]} />
                </span>
                Linked Pricebook
              </div>
              <div
                data-test="documentdetails-docinfo-linked-pricebook"
                className="documentdetails-col meta-value">
                {linkedPriceBookName}
              </div>
            </div>

            {/* Owner */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "user"]} />
                </span>
                Owner
              </div>
              <div className="documentdetails-col meta-value">
                <span className="documentdetails-imgwrapper">
                  <img
                    data-test="documentdetails-docinfo-document-owner-img"
                    className="documentdetails-img"
                    src={docOwnerProfileImageUrl}
                    alt="Collaborators Profile"
                  />
                </span>
                <span data-test="documentdetails-docinfo-document-owner">
                  {docOwner}
                </span>
              </div>
            </div>
            {/* Document Creation Date */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                </span>
                Document Creation Date
              </div>
              <div
                data-test="documentdetails-docinfo-document-creation-date"
                className="documentdetails-col meta-value">
                {GlobalUtils.formatDate(docCreatedDate, "ll") || "-"}
              </div>
            </div>
            {/* Last updated */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                </span>
                Last updated
              </div>
              <div
                data-test="documentdetails-docinfo-document-last-updated"
                className="documentdetails-col meta-value">
                {GlobalUtils.formatDate(oppLastUpdated, "ll") || "-"}
              </div>
            </div>
            <span className="h-line" />
            {/* Account Name */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "briefcase"]} />
                </span>
                Account Name
              </div>
              <div
                data-test="documentdetails-docinfo-document-account-name"
                className="documentdetails-col meta-value">
                {accountName || "-"}
              </div>
            </div>
            {/*  Account Details */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "building"]} />
                </span>
                Account address
              </div>
              <div
                data-test="documentdetails-docinfo-document-account-address"
                className="documentdetails-col meta-value">
                {accountAddress || "-"}
              </div>
            </div>

            {/* Close Date */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                </span>
                Close Date
              </div>
              <div
                data-test="documentdetails-docinfo-document-account-close-date"
                className="documentdetails-col meta-value">
                {GlobalUtils.formatDate(oppCloseDate, "ll") || "-"}
              </div>
            </div>

            {/* Expected Revenue */}
            <div className="documentdetails-row">
              <div className="documentdetails-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["far", "money-bill-wave"]} />
                </span>
                Expected Revenue
              </div>
              <div
                data-test="documentdetails-docinfo-document-account-expected-revenue"
                className="documentdetails-col meta-value">
                ${oppExpectedRevenue || "-"}
              </div>
            </div>

            {/* Evidence Summary */}
            <div className="documentdetails-row-evidence">
              <div className="documentdetails-evidence-col meta-title">
                <span className="documentdetails-col-icon">
                  <FontAwesomeIcon icon={["fas", "file-pdf"]} />
                </span>
                Evidence Summary PDF
                <span className="new-evidence-tag">New</span>
              </div>
              {this.props.document.stage === "COMPLETED" &&
              this.props.document.is_sent_for_signature ? (
                <div
                  className="documentdetails-evidence-col meta-value"
                  role="button"
                  tabIndex={0}
                  onClick={() => this._downloadEvidenceSummary()}
                  onKeyPress={() => {}}>
                  <u>Click to download</u>
                </div>
              ) : (
                <div className="documentdetails-evidence-col meta-sub-value">
                  Evidence summary will be generated automatically once this
                  document is eSigned
                </div>
              )}
            </div>

            {/* EXPIRY Date */}
            {/* <div className="documentdetails-row">
            <div className="documentdetails-col meta-title">
              <span className="documentdetails-col-icon">
                <FontAwesomeIcon icon={["far", "calendar-alt"]} />
              </span>
              EXPIRY Date
            </div>
            <div className="documentdetails-col meta-value">
              {GlobalUtils.formatDate(docCloseDate, "ll") || "-"}
            </div>
          </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // ::QUOTATION STORE
  const { dealTableId, view: currentView } = state.QuotationStore;

  // ::DEALTABLE STORE
  const {
    priceBook: { [dealTableId]: priceBook = {} } = {},
  } = state.DealTableStore;

  // ::DOCUMENT STORE
  const { document } = state.DocumentStore;

  // ::ASSIGN REDUX KEYS TO RESPECTIVE DECLARED PROP VALUES
  const selectedPriceBook = (priceBook && priceBook.name) || "";
  return {
    currentView,
    document,
    selectedPriceBook,
  };
};

export default connect(
  mapStateToProps,
  null,
)(DocumentDetails);



// WEBPACK FOOTER //
// ./src/components/DocumentDetails/index.js